import React, { Component } from 'react';
import './Login.css';
import qBankApi from '../services/qbankApi';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";

class UsernameInput extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        this.props.updateUsername(e.target.value);
    }
    render() {
        return (
            <FormGroup controlId="login-username">
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                        type="email"
                        label="Email"
                        onChange={this.handleChange}
                    />
            </FormGroup>
        );
    }
}

class NameInput extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        this.props.updateName(e.target.value);
    }
    render() {
        return (
            <FormGroup controlId="login-name">
                <Col componentClass={ControlLabel} sm={2}>
                    Name
                </Col>
                <Col sm={10}>
                    <FormControl type="text" onChange={this.handleChange}/>
                </Col>
            </FormGroup>
        );
    }
}

class PasswordInput extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        this.props.updatePassword(e.target.value);
    }
    render() {
        return (
            <FormGroup controlId="login-password">
                    <ControlLabel>Password</ControlLabel>
                    <FormControl
                        type="password"
                        label="Password"
                        onChange={this.handleChange}
                    />
            </FormGroup>
        );
    }
}

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            errorMessage: ""
        };
        this.updateUsername = this.updateUsername.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }
    updateUsername(username) {
        this.setState({'username': username});
    }
    updatePassword(password) {
        this.setState({'password': password});
    }
    handleLogin(event) {
        let authData = { Username: this.state.username, Password: this.state.password };
        this.props.handleLogin(authData);
        event.preventDefault();
    }
    render() {
        return (
            <div className="panes">
                <div className="image-pane">
                    <img src={require('./landing_page_background.png')} className="landing-image" alt="Background" />
                    <img src={require('./qbank_com.svg')} className="logo-overlay" alt="QBank.com" />
                    <div className="text-overlay">
                        Finally! A comprehensive and affordable medical student question bank
                        is coming Summer 2020.
                    </div>
                </div>

                <div className="form-pane">
                    <img src={require('./q_vector.svg')} className="qbank-logo" alt="QBank logo" />
                    <div className="login-flavor-text">
                        Login to Your Account
                    </div>
                    { this.props && this.props.errorMessage &&
                        <div className="error-message">
                            { this.props.errorMessage }
                        </div>
                    }
                    <Form horizontal className="login" onSubmit={this.handleLogin}>
                        <UsernameInput updateUsername={this.updateUsername}/>
                        <PasswordInput updatePassword={this.updatePassword}/>
                        <FormGroup>
                            <div className="sign-in-button">
                                <Button type="submit" bsStyle="info">Sign In</Button>
                            </div>
                            <Link className="reset-password" to="/resetpassword">
                                <Button type="button" bsStyle="link">Reset password</Button>
                            </Link>
                        </FormGroup>
                    </Form>
                </div>
            </div>
        );
    }
}

class NewPasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            password: ""
        };
        this.updateName = this.updateName.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }
    updateName(name) {
        this.setState({'name': name});
    }
    updatePassword(password) {
        this.setState({'password': password});
    }
    handleLogin(event) {
        this.props.completePasswordChallenge(this.state.name, this.state.password);
        event.preventDefault();
    }
    render() {
        return (
            <Form horizontal className="login" onSubmit={this.handleLogin}>
                <NameInput updateName={this.updateName}/>
                <PasswordInput updatePassword={this.updatePassword}/>
                <FormGroup>
                    <Col smOffset={2} sm={10}>
                        <Button type="submit" bsStyle="primary">Reset Password</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: "",
            authenticationCallbacks: null,
            newPasswordRequired: false
        };
        this.updateError = this.updateError.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleNewPasswordChallenge = this.handleNewPasswordChallenge.bind(this);
        this.completeNewPasswordChallenge = this.completeNewPasswordChallenge.bind(this);
    }
    updateError(error) {
        this.setState({'error': error.message || error});
    }
    handleLogin(authData) {
        qBankApi.doLogin(authData.Username, authData.Password)
            .then(response => {
                if (response.status === 401) {
                    this.updateError('Username or password incorrect, please try again');
                } else {
                    window.location.reload();
                }
            }).catch(error => {
                console.log('Error logging in\n', error);
                this.updateError('Failed to connect to server, please try again');
            });;

    }
    handleNewPasswordChallenge(cognitoUser, authenticationCallbacks) {
        this.setState({
            'authenticationCallbacks': authenticationCallbacks,
            'newPasswordRequired': true
        });
    }
    completeNewPasswordChallenge(name, password) {
    }
    render() {
        let loginForm = <LoginForm handleLogin={this.handleLogin} errorMessage={this.state.error || this.props.message} />;
        if (this.state.newPasswordRequired) {
            loginForm = <NewPasswordForm completePasswordChallenge={this.completeNewPasswordChallenge}/>;
        }

        return (
            <div>
                {loginForm}
            </div>
        );
    }
}



export default Login;
